import React from 'react';

interface RoundButtonProps {
  isSelected: boolean;
  value: string;
  image: string;
  setAsSelected: () => void;
  disabled?: boolean;
}
export const RoundButton: React.FC<RoundButtonProps> = ({
  isSelected,
  setAsSelected,
  value,
  image,
  disabled = false,
}) => {
  return (
    <button
      style={{ backgroundColor: isSelected ? '#6571FF' : 'white' }}
      className={`flex items-center space-x-2 border-1  border-blue-600 py-[0.5rem] px-[1.5rem] rounded-full min-w-[8rem] bg-${
        isSelected ? 'blue-600' : 'white'
      } ${disabled && 'opacity-50'}`}
      onClick={() => setAsSelected()}
      disabled={disabled}
    >
      <div className="flex flex-row  space-x-1 mx-auto  ">
        <img title="material" src={image} className={`${isSelected && 'invert filter brightness-0'}`}></img>
        <span style={{ color: isSelected ? 'white' : '#6571FF' }}>{value}</span>
      </div>
    </button>
  );
};
